import Bowser from "bowser";

export type BrowserSupportedOutcome =
  | {
      outcome: "success";
    }
  | {
      outcome: "failed";
      reason: "unsupported-browser";
      details: {
        browserName?: string;
        browserVersion?: string;
      };
    }
  | {
      outcome: "failed";
      reason: "unable-to-detect-browser";
      error?: unknown;
    }
  | {
      outcome: "failed";
      reason: "outdated-browser";
      details: {
        browserName: string;
        browserVersion: string;
        minimumSupportedVersion: string;
      };
    };

// Broadly set to version from Dec 2022, except for Safari where we
// do not support 15 and users must move to 16+ for PDF rendering to work
const defaultSupportedBrowserVersions: { [key: string]: string } = {
  Safari: ">=16",
  Chrome: ">=108",
  "Microsoft Edge": ">=108",
  Electron: ">=37",
  Chromium: ">=108",
  Firefox: ">=108",
  "Samsung Internet for Android": ">=21",
};

export function isBrowserSupported(
  userAgentString: string,
  satisfiesCheck: { [key: string]: string } = defaultSupportedBrowserVersions,
): BrowserSupportedOutcome {
  try {
    const browser = Bowser.getParser(userAgentString);

    const { name: browserName, version: browserVersion } = browser.getBrowser();

    console.log(browser);

    const checkResult = browser.satisfies(satisfiesCheck);

    if (checkResult === false) {
      return {
        outcome: "failed",
        reason: "outdated-browser",
        details: {
          browserName: browserName ?? "unknown",
          browserVersion: browserVersion ?? "unknown",
          minimumSupportedVersion:
            defaultSupportedBrowserVersions[browserName ?? "unknown"] ??
            "unknown",
        },
      };
    }
    // Undefined is returned from 'satisfies' when the browser is not listed in supportedBrowserVersions
    else if (checkResult === undefined) {
      return {
        outcome: "failed",
        reason: "unsupported-browser",
        details: {
          browserName,
          browserVersion,
        },
      };
    }

    return {
      outcome: "success",
    };
  } catch (e: unknown) {
    return {
      outcome: "failed",
      reason: "unable-to-detect-browser",
      error: e,
    };
  }
}
